<template>
  <div id="rank">

      <div class="d-flex pt-2 pl-2">
        <span class="icon-cube" style="color:#5cd9e8;font-size: 0.3rem;width: 100%">
           <span class="fs-xl text mx-2" style="font-size: 0.25rem;color: #ffffff">机构排行</span>
        </span>
      </div>
      <div class="caption" style="width: 100%;overflow: hidden;margin-top: 0.2rem">
        <a class="float-l"  :class="{active:Index==0}" @click="show(0)">交易次数榜</a>
        <i class="float-l " style="line-height:25px;border-right:2px solid #4c9bfd;margin:0 0.2rem;height:25px"></i>
        <a class="float-l"  :class="{active:Index==1}" @click="show(1)">机构评分榜</a>
        <i class="float-l " style="line-height:25px;border-right:2px solid #4c9bfd;margin:0 0.2rem;height:25px"></i>
        <a class="float-l"  :class="{active:Index==2}" @click="show(2)">机构活跃度榜</a>
      </div>
      <div class="d-flex jc-center body-box" style=" margin-top: 0;padding: 0 0.2rem;width: 100%;height: 80%">
        <dv-scroll-ranking-board :config="config" style="width:100%;height:100%"/>
      </div>
    </div>
</template>

<script>
// import * as $ from 'jquery'
import sciApi from '@/api/index.js'
export default {
  data() {
    return {
      dialogVisible: false,
      Index:0,
      Num:{},
      val:[],
      dataList:[],
      number: [],
      live:[],
      score: [],
      config:{
        unit: '个',
        rowNum:4,
        waitTime:3000,
        data:[
        ]
      }
    };
  },
  watch:{
    Index:{
      immediate: true,
      deep: true,
      handler(val) {
        if(val==0){
          this.init().then(()=>{
            let num=[]
            for(let i in this.number){
              if (this.number[i].name !=='政策'){
                num.push(this.number[i])
              }
            }
            this.config ={unit: '次', rowNum:4,data:num}
            console.log(num,'交易')
          })
        }else
          if(val==1){
          this.init().then(()=>{
            let num=[]
            for(let i in this.score){
              if (this.score[i].name !=='政策'){
                num.push(this.score[i])
              }
            }
            this.config ={unit: '分', rowNum:4,data:num}
            console.log(num,'分')
          })

        }
        else if(val==2){
          this.init().then(()=>{
            let num=[]
            for(let i in this.live){
              if (this.live[i].name !=='政策'){
                num.push(this.live[i])
              }
            }
            this.config ={ rowNum:4,data:num}
            console.log(num,'活跃')
          })
        }
      }
    }

  },
  mounted() {
    this.tag=''
    this.Index=0
    this.init().then(()=>{
      let num=[]
      for(let i in this.number){
        if (this.number[i].name !=='政策'){
          num.push(this.number[i])
        }
      }
      this.config ={unit: '次', rowNum:4,data:num}
    })
  },
  methods: {
    show(i){
     this.Index=i
    },
    async init(){
      // await sciApi.selectMall({})
      await sciApi.selectList({pageSize: 1000,pageNum: 1}).then((data)=>{
        // data 就是接口返回值
        this.number=[]
        this.score=[]
        this.live=[]
        this.dataList = data.list || []
          this.dataList.forEach((item) => {
              this.Num[item.shopName]=item
          })
          let names = Object.keys(this.Num)
          names.forEach(()=>{
            this.number.push({name:'政策',value:0})
            this.score.push({name:'政策',value:0})
            this.live.push({name:'政策',value:0})
          })
          // console.log(names,'names')
          // 累加数据
          this.dataList.forEach((item) => {
            // console.log(item,'item')
            let idx = names.indexOf(item.shopName)
            if (idx != -1) {
              //交易次数
              if(item.countList){
                this.number[idx].name = names[idx] || '政策'
                this.number[idx].value = Number(item.countList||0 )
              }
              //评分
              if(item.gradeList){
                this.score[idx].name = names[idx] || '政策'
                this.score[idx].value = Number(item.gradeList||0 )
              }
              //活跃度
              if(item.activeList){
                this.live[idx].name = names[idx] || '政策'
                this.live[idx].value = Number(item.activeList||0 )
              }
            }
          })
      })
    },
    drawLine:function (){
      // var Data = {
      //   number: [],
      //   score: []
      // }
      // var _this = this
      // //合作方式切换数据
      // $('.caption').on('click', 'a', function () {
      //   $(this).addClass('active').siblings('a').removeClass('active');
      //   //option series   data
      //   //获取自定义属性值
      //   var key = $(this).attr('data-type');
      //   //取出对应的值
      //   key = Data[key];
      //
      //   //将值设置到 图表中
      //   _this.config ={unit: '个', rowNum:6,data:key}
      //   //刷新组件
      //   //   _this.config = { ..._this.config }
      //
      //   //再次调用才能在页面显示
      // });

      //定时器
      // var index = 0;
      // setInterval(function () {
      //   index++;
      //   if (index >2) {
      //     index = 0;
      //   }
      //   $('.caption a').eq(index).click();
      // }, 2000);
    },
  }
};
</script>

<style lang="scss">
#rank {
  padding: 0.2rem;
  height: 100%;
  width: 100%;
  //border-radius: 0.0625rem;
  .bg-color-black {
    padding: 0.0625rem;
    height: 4.5rem;
    border-radius: 0.125rem;
  }
  .caption{
    line-height: 25px;
    margin-left: 0.2rem;
  }
  .caption a{
    text-align: center;
    width: 25%;
    font-size: 18px;
    color: #4c9bfd;
    line-height: 25px;
    padding: 0 0.1rem;
  }
  .caption a.active{
    background-color: #4c9bfd;
    color: #fff;
    border-radius: 2px;
  }

  .text {
    color: #c3cbde;
  }
  .body-box {
    border-radius: 0.125rem;
    overflow: hidden;
  }
}
</style>